var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenubarIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 0 17.16 0 26 0 C26 1.32 26 2.64 26 4 C17.42 4 8.84 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(3,22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 0 17.16 0 26 0 C26 1.32 26 2.64 26 4 C17.42 4 8.84 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(3,14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 0 17.16 0 26 0 C26 1.32 26 2.64 26 4 C17.42 4 8.84 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(3,6)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubarIconMobile);
export default __webpack_public_path__ + "static/media/menubarIconMobile.b942cf160045c67d79df52a8639e468f.svg";
export { ForwardRef as ReactComponent };